import {
  createLocation,
  getLocationById,
  getLocationHome,
  requestEditLocation,
  updateLocation,
  updateLocationChecklistSettings,
  updateLocationEssentialInsurances,
} from '@/api'
import { Location, LocationHome } from '@/types/location'
import { useInvalidateOnSuccessMutation } from '@/utils'
import { UseQueryOptions, useMutation, useQuery } from 'react-query'

const keys = {
  locations: 'locations',
  location: 'location',
  location1: 'location1',
}

export const useLocation = (id: string, options?: UseQueryOptions<Location>) =>
  useQuery<Location>([keys.location1, id], () => getLocationById(id), options)

export const useLocationHome = (
  { id, archived }: { id: string; archived?: boolean },
  options?: UseQueryOptions<
    LocationHome,
    unknown,
    LocationHome,
    Array<string | boolean | undefined>
  >,
) =>
  useQuery(
    [keys.location, id, archived],
    () => getLocationHome(id, archived),
    options,
  )

export const useLocationHomeActiveView = (
  { id }: { id: string },
  options?: UseQueryOptions<LocationHome, unknown, LocationHome, Array<string>>,
) => useQuery([keys.location, id], () => getLocationHome(id, false), options)

export const useCreateLocation = (id: string) =>
  useInvalidateOnSuccessMutation(
    [keys.locations, 'companies'],
    ({ companyId, name, address }) =>
      createLocation({
        name,
        address,
        companyId: id || companyId,
      }),
  )

export const useUpdateLocation = (id: string) =>
  useInvalidateOnSuccessMutation(keys, ({ name }) =>
    updateLocation({ id, name }),
  )

export const useUpdateLocationEssentialInsurances = (id: string) =>
  useInvalidateOnSuccessMutation(keys, ({ essentialCategoryId }) =>
    updateLocationEssentialInsurances({ id, essentialCategoryId }),
  )

export const useRequestEditLocation = (id: string) =>
  useMutation(() => requestEditLocation(id))

export const useUpdateLocationChecklistSettings = (id: string) =>
  useInvalidateOnSuccessMutation([[keys.location, id]], () =>
    updateLocationChecklistSettings(id),
  )
